module.exports = __webpack_public_path__ + "img/sjobodar.10d027ff.jpg";